import { isAfter } from 'date-fns'
import { isEmpty } from 'lodash'
import { AllClinicsAvailabilitiesGroupedByPeriod } from '@context/AppointmentCalendarContext/types'

export const calculateDayWithNextAvailableSlot = (
  clinicId: string,
  availabilitiesGrouped: AllClinicsAvailabilitiesGroupedByPeriod | undefined,
  periodRangeEnd?: string
) => {
  if (isEmpty(availabilitiesGrouped)) return

  const availabilities = availabilitiesGrouped[clinicId]

  const firstPeriodWithAvailabilities = (availabilities || []).find((av) =>
    av.find((day) => isAfter(new Date(day.date), new Date(periodRangeEnd || '')) && !!day.availabilities.length)
  )
  const day = firstPeriodWithAvailabilities?.find((day) => !!day.availabilities.length)?.date

  return day
}
